<template>
  <crud-form
    v-model="payload"
    :request-class="requestClass"
    page-title="Criar contrato de adquirente"
    navigate-back-route="contacard.submodules.list"
    :total-group="1"
    :override-create-payload="overrideCreatePayload"
    :remove-buttons="true"
    :remove-card="true"
    @success="validateSuccess($event)"
  >
    <template slot="group-1">
      <v-row>
        <v-col cols="12">
          <v-stepper v-model="stepper">
            <v-stepper-header>
              <v-stepper-step step="1">
                Configuar loja
              </v-stepper-step>
              <v-stepper-step step="2">
                Dados da loja
              </v-stepper-step>
              <v-stepper-step step="3">
                Dados bancários
              </v-stepper-step>
              <v-stepper-step step="4">
                Taxas
              </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-card-title>
                    <h4>Informe os dados para cadastro:</h4>
                  </v-card-title>
                  <v-card-text>
                    <form-group>
                      <v-row>
                        <v-col cols="6">
                          <v-row>
                            <v-col cols="9">
                              <input-mask
                                id="input:document"
                                v-model="payload.document"
                                label="Documento do Estabelecimento"
                                :rules="[requiredRule]"
                                required
                                outlined
                                clearable
                              />
                            </v-col>
                            <v-col cols="3">
                              <v-btn
                                color="primary"
                                outlined
                                :loading="storeLoading"
                                :disabled="isDisabledSearch"
                                @click="search()"
                              >
                                <v-icon>mdi-magnify</v-icon>
                                Pesquisar
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="7">
                          <v-row>
                            <v-col cols="12">
                              <input-select
                                v-model="payload.store"
                                label="Loja"
                                :loading="storeLoading"
                                :items="stores"
                                :disabled="isDisabledStore"
                                :rules="[requiredRule]"
                                return-object
                                required
                                outlined
                              />
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </form-group>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="#6A6E7B"
                      outlined
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="ml-2"
                      :disabled="isDisabledFirstNext"
                      :loading="validateLoading"
                      @click="validateStoreAndNest()"
                    >
                      Próximo
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-card-title>
                    <h4>Informe os dados para cadastro:</h4>
                  </v-card-title>
                  <v-card-text>
                    <form-group v-if="!hasCnpj">
                      <v-row>
                        <v-col cols="6">
                          <input-text
                            id="input:rg"
                            v-model="payload.rg"
                            label="RG"
                            :rules="[requiredRule]"
                            required
                            outlined
                          />
                        </v-col>
                        <v-col cols="6">
                          <input-text
                            id="input:nacionalidade"
                            v-model="payload.nacionalidade"
                            label="Nacionalidade"
                            outlined
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-combobox
                            v-model="payload.segmento"
                            label="Segmento"
                            :loading="segmentLoading"
                            :items="segments"
                            :disabled="!segments.length"
                            :rules="[requiredRule]"
                            placeholder="Digite ou selecione"
                            required
                            outlined
                          />
                        </v-col>
                        <v-col cols="6">
                          <input-select
                            v-model="payload.mcc"
                            :error="isInvalidMcc"
                            label="MCC"
                            :loading="segmentLoading || mccLoading"
                            :items="mcc"
                            :disabled="!mcc.length"
                            :rules="[requiredRule]"
                            :error-messages="isInvalidMcc ? ['MCC Inválido!'] : []"
                            required
                            outlined
                            readonly
                          />
                        </v-col>
                      </v-row>
                    </form-group>
                    <form-group v-else>
                      <v-row>
                        <v-col cols="6">
                          <input-text
                            id="input:rg"
                            v-model="payload.rg"
                            label="RG"
                            :rules="[requiredRule]"
                            required
                            outlined
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-combobox
                            v-model="payload.cnae"
                            placeholder="Digite ou selecione"
                            label="CNAE"
                            :loading="cnaeLoading"
                            :items="cnaes"
                            :disabled="!cnaes.length"
                            :rules="[requiredRule]"
                            required
                            outlined
                          />
                        </v-col>
                        <v-col cols="6">
                          <input-select
                            v-model="payload.mcc"
                            label="MCC"
                            :loading="cnaeLoading || mccLoading"
                            :items="mcc"
                            :disabled="!mcc.length"
                            :rules="[requiredRule]"
                            :error="isInvalidMcc"
                            :error-messages="isInvalidMcc ? ['MCC Inválido!'] : []"
                            required
                            outlined
                            readonly
                          />
                        </v-col>
                      </v-row>
                    </form-group>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="#6A6E7B"
                      outlined
                      @click="next(1)"
                    >
                      Voltar
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="ml-2"
                      :disabled="isInvalidMcc || isDisabledSecondNext"
                      @click="next(3)"
                    >
                      Próximo
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-card>
                  <v-card-title>
                    <h4>Informe os dados para cadastro:</h4>
                  </v-card-title>
                  <v-card-text>
                    <form-group>
                      <v-row>
                        <v-col cols="6">
                          <input-text
                            id="input:nomLoja"
                            v-model="getSelectStore.nomLoja"
                            label="Razão social / Cliente"
                            outlined
                            disabled
                          />
                        </v-col>
                        <v-col cols="6">
                          <input-mask
                            v-if="!hasCnpj"
                            id="input:document"
                            :value="getStoreDocument"
                            label="Documento"
                            outlined
                            disabled
                          />
                          <v-row
                            v-else
                            justify="start"
                            align="center"
                          >
                            <v-col cols="8">
                              <input-text
                                v-mask="'##.###.###'"
                                :value="getInitialDigitsFromStoreDocument"
                                label="Documento"
                                outlined
                                disabled
                              />
                            </v-col>
                            <v-col cols="4">
                              <input-text
                                v-model="lastDigitsFromStoreDocument"
                                v-mask="'/####.##'"
                                label=""
                                outlined
                              />
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <input-select
                            id="input:tipoContaBancaria"
                            v-model="payload.contaBancaria.tipoContaBancaria"
                            :items="tipoContaBancarias"
                            label="Tipo da conta"
                            :rules="[requiredRule]"
                            required
                            outlined
                          />
                        </v-col>
                        <v-col cols="6">
                          <v-combobox
                            id="input:bancoId"
                            v-model="payload.contaBancaria.bancoId"
                            placeholder="Digite ou selecione"
                            :loading="bankLoading"
                            :items="bankOptions"
                            label="Banco"
                            :rules="[requiredRule]"
                            :disabled="!bankOptions.length"
                            clearable
                            required
                            outlined
                          />
                        </v-col>
                      </v-row>
                      <v-row />
                      <v-row>
                        <v-col cols="3">
                          <input-text
                            id="input:numeroAgencia"
                            v-model="payload.contaBancaria.numeroAgencia"
                            label="Número da agência"
                            :rules="[requiredRule]"
                            required
                            outlined
                          />
                        </v-col>
                        <v-col cols="6">
                          <input-text
                            id="input:numeroConta"
                            v-model="payload.contaBancaria.numeroConta"
                            label="Número da conta"
                            :rules="[requiredRule]"
                            required
                            outlined
                          />
                        </v-col>
                        <v-col cols="3">
                          <input-text
                            id="input:digitoConta"
                            v-model="payload.contaBancaria.digitoConta"
                            label="Dígito da conta"
                            :rules="[requiredRule]"
                            required
                            outlined
                          />
                        </v-col>
                      </v-row>
                    </form-group>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="#6A6E7B"
                      outlined
                      @click="next(2)"
                    >
                      Voltar
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="ml-2"
                      :disabled="isDisabledThirdNext"
                      @click="next(4)"
                    >
                      Próximo
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="4">
                <v-card>
                  <v-card-title>
                    <h4>Informe os dados para cadastro:</h4>
                  </v-card-title>
                  <v-card-text>
                    <form-group>
                      <v-row>
                        <v-col cols="6">
                          <input-radio
                            v-model="payload.comAntecipacao"
                            :options="comAntecipacaoOptions"
                            label="Antecipação automática"
                            :disabled="disabledComAntecipacao"
                            :rules="!disabledComAntecipacao ? [requiredRule] : []"
                            row
                          />
                        </v-col>
                        <v-col cols="6">
                          <input-money
                            v-model="payload.custoLocacao"
                            label="Custo locação"
                            outlined
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <input-select
                            v-model="payload.tabelaDePrecoId"
                            label="Tabela de preço"
                            :loading="priceLoading"
                            :items="prices"
                            :disabled="!prices.length"
                            :rules="[requiredRule]"
                            required
                            outlined
                          />
                        </v-col>
                        <v-col cols="6">
                          <input-select
                            v-model="payload.faixaId"
                            label="Faixa de faturamento"
                            :loading="ratesLoading"
                            :items="rates"
                            :disabled="!rates.length"
                            :rules="[requiredRule]"
                            required
                            outlined
                          />
                        </v-col>
                      </v-row>
                    </form-group>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="#6A6E7B"
                      outlined
                      :loading="laoding"
                      @click="next(3)"
                    >
                      Voltar
                    </v-btn>
                    <v-btn
                      color="success"
                      class="ml-2"
                      type="submit"
                      :disabled="isDisabledSave"
                      :loading="laoding"
                    >
                      Salvar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
        <v-dialog
          v-model="isAnalysisTable"
          max-width="500"
          persistent
        >
          <v-card>
            <v-card-title>
              Registro pendente!
            </v-card-title>
            <v-card-text>
              <p>
                O registro foi para mesa de análise, vá para a listagem e avalie o registro.
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="#6A6E7B"
                outlined
                @click="closeAnalyis()"
              >
                Entendi
              </v-btn>
              <v-btn
                color="primary"
                class="ml-2"
                @click="navigateTo('adqTable.list')"
              >
                Ir para mesa
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </crud-form>
</template>

<script>
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import LojaRequest from '@/app/client/store/StoreRequest';
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import TypeAccountBanks from 'Arch/enums/TypeAccountBanks';
import BanksRequest from 'Modules/contacard/banks/BanksRequest';
import NotificationMixin from '@/app/arch/mixins/NotificationMixin';
import RouterMixin from '@/app/arch/mixins/RouterMixin';
import AdqRequest from './AdqRequest';
import AdqTaxService from '../establishment/AdqTaxService';
import AdqTablePriceService from '../establishment/AdqTablePriceService';

const initialPayload = {
  filialDocument: '',
  document: '',
  store: {},
  segmento: '',
  mcc: '',
  cnae: '',
  comAntecipacao: '',
  faixaId: '',
  tabelaDePrecoId: '',
  custoLocacao: '',
  nacionalidade: 'brasileira',
  rg: '',
  contaBancaria: {
    bancoId: '',
    holderType: '',
    tipoContaBancaria: '',
    numeroConta: '',
    numeroAgencia: '',
    digitoConta: '',
    digitoAgencia: '',
  },
};

function makeInitialData() {
  return Object.keys(initialPayload)
    .reduce(
      (obj, key) => {
        const override = obj;
        const item = initialPayload[key];

        override[key] = item !== null && typeof item === 'object' ? { ...item } : item;

        return override;
      },
      {},
    );
}

export default {
  name: 'AdqForm',
  components: { CrudForm, FormGroup },
  mixins: [NotificationMixin, RulesMixin, RouterMixin],
  data: () => ({
    storeRequest: LojaRequest,
    requestClass: AdqRequest,
    bankRequest: BanksRequest,
    tablePriceService: AdqTablePriceService,
    taxService: AdqTaxService,
    stepper: 1,
    storeLoading: false,
    segmentLoading: false,
    mccLoading: false,
    validateLoading: false,
    disabledComAntecipacao: false,
    cnaeLoading: false,
    bankLoading: false,
    priceLoading: false,
    ratesLoading: false,
    laoding: false,
    isInvalidMcc: false,
    isAnalysisTable: false,
    stores: [],
    segments: [],
    mcc: [],
    cnaes: [],
    bankOptions: [],
    prices: [],
    rates: [],
    tipoContaBancarias: TypeAccountBanks,
    payload: { ...makeInitialData() },
    comAntecipacaoOptions: [
      {
        label: 'Sim',
        value: true,
      },
      {
        label: 'Não',
        value: false,
        color: 'primary',
      },
    ],
  }),
  computed: {
    isDisabledSearch() {
      return this.onlyNumber(this.payload.document).length < 11;
    },
    isDisabledStore() {
      return !this.stores.length;
    },
    isDisabledFirstNext() {
      const { store } = this.payload;

      if (typeof store !== 'object' || store === null) { return true; }

      if (Array.isArray(store) && store.length) { return !store[0].value; }

      return !store.value;
    },
    isDisabledSecondNext() {
      const {
        cnae, mcc, segmento, rg,
      } = this.payload;
      return ![mcc, rg, this.hasCnpj ? cnae : segmento].every((value) => value !== '');
    },
    isDisabledSave() {
      const { comAntecipacao, faixaId, tabelaDePrecoId } = this.payload;
      return !(faixaId || tabelaDePrecoId || typeof comAntecipacao === 'boolean');
    },
    isDisabledThirdNext() {
      const { contaBancaria } = this.payload;
      return Object.keys(contaBancaria)
        .filter((key) => !['digitoAgencia', 'holderType'].includes(key))
        .some((key) => !contaBancaria[key]);
    },
    hasCnpj() {
      return this.getStoreDocument.length > 11;
    },
    getSelectStore() {
      const { store: { store = {} } = {} } = this.payload;
      return store;
    },
    getStoreDocument() {
      const { numCnpj, numDocumentoCliente } = this.getSelectStore;
      return this.onlyNumber(
        numCnpj || numDocumentoCliente,
      );
    },
    getInitialDigitsFromStoreDocument() {
      return this.getStoreDocument.split('').slice(0, 8).join('');
    },
    lastDigitsFromStoreDocument: {
      get() {
        return this.getStoreDocument.split('').slice(8, 14).join('');
      },
      set(value) {
        this.payload.filialDocument = this.onlyNumber(value);
      },
    },
    getFilialDocument() {
      return `${this.getInitialDigitsFromStoreDocument}${this.onlyNumber(
        this.payload.filialDocument || this.lastDigitsFromStoreDocument,
      )}`;
    },
  },
  watch: {
    'payload.segmento': {
      deep: true,
      immediate: true,
      handler(segment) {
        if (!!segment && typeof segment === 'object') {
          this.payload.mcc = '';
          this.getMcc();
        }
      },
    },
    'payload.cnae': {
      deep: true,
      immediate: true,
      handler(cnae) {
        if (!!cnae && typeof cnae === 'object') {
          this.payload.mcc = '';
          this.getMcc();
        }
      },
    },
  },
  methods: {
    async search() {
      try {
        this.storeLoading = true;
        const { data: { data } = {} } = await this.requestClass.infoSgv(
          this.onlyNumber(
            this.payload.document,
          ),
        );

        this.validateStore(data);
      } catch (err) {
        this.handleError(err);
      } finally {
        this.storeLoading = false;
      }
    },
    prepareStoreName(data = []) {
      return data
        .reduce(
          (stores, store) => {
            const {
              idEstabelecimentoAdq, id, nomLoja, idClienteSgv,
            } = store;
            if (!idEstabelecimentoAdq && !!idClienteSgv) {
              stores.push({
                value: idClienteSgv,
                text: `${id} - ${nomLoja} (${idClienteSgv || 0})`,
                store,
              });
            }
            return stores;
          },
          [],
        );
    },
    onlyNumber(value) {
      if (!value) return '';
      return String(value).trim().replace(/[^0-9]/g, '');
    },
    next(step) {
      this.stepper = step;

      if (step === 3 && !this.bankOptions.length) {
        this.getBanks();
      }

      if (step === 4) {
        if (!this.rates.length) {
          this.getRates();
        }

        if (!this.prices.length) {
          this.getPrices();
        }
      }
    },
    async validateStoreAndNest() {
      const { store } = this.payload.store;
      const motivo = `Motivo: ${store.motivo}`;

      switch (store.situacaoInteresseAdq) {
        case 'SEM_INTERESSE': {
          await this.showOkDialog({
            title: 'Atenção',
            text: `PDV com restrição, não dar continuidade ao seu cadastro por desinteresse comercial. ${motivo}`,
          });

          return;
        }
        case 'INTERESSE_SEM_ANTECIPACAO': {
          const data = await this.showConfirmDialog({
            title: 'Atenção',
            text: `PDV com restrição, seguir o credenciamento caso ele concorde com as novas taxas sem antecipação. ${motivo}`,
          });

          if (!data.value) { return; }

          this.disabledComAntecipacao = true;
          this.payload.comAntecipacao = false;
          break;
        }
        case 'INTERESSE_COM_ANTECIPACAO': {
          this.disabledComAntecipacao = !this.hasCnpj;
          this.payload.comAntecipacao = !this.hasCnpj || '';
          break;
        }
        default:
          break;
      }

      this.nextGetStoreInfo();
    },
    async validateStore(data = []) {
      const stores = this.prepareStoreName(data);

      if (!stores.length) {
        this.showErrorToast({
          text: 'Nenhuma loja válida para cadastro foi encontrada!',
        });
        return;
      }

      this.stores = stores;

      if (stores.length === 1) {
        const [store] = stores;
        this.payload.store = store;
      }
    },
    nextGetStoreInfo() {
      if (!this.hasCnpj) {
        this.listSegments();
      } else {
        this.listCnaes();
      }
      this.next(2);
    },
    async listSegments() {
      try {
        this.segmentLoading = true;
        const { data } = await this.requestClass.listSegments(
          this.makeParams(),
        );

        this.segments = this.getSegmentsItems(data.data);
      } catch (err) {
        this.handleError(err);
      } finally {
        this.segmentLoading = false;
      }
    },
    getSegmentsItems(data = []) {
      return data.reduce(
        (items, segment) => {
          items.push({
            text: segment.descricao,
            value: segment.id,
          });
          return items;
        },
        [],
      );
    },
    async listCnaes() {
      try {
        this.cnaeLoading = true;
        const { data = [] } = await this.requestClass.listCnaeByStoreDocument(
          this.getStoreDocument,
        );

        this.cnaes = data.map(
          (item) => ({
            text: `(${item.value}) - ${item.description}`,
            value: item.value,
          }),
        );
      } catch (err) {
        this.handleError(err);
      } finally {
        this.cnaeLoading = false;
      }
    },
    async getMcc() {
      try {
        this.mccLoading = true;
        if (!this.hasCnpj) {
          await this.getMccBySegment();
          return;
        }

        await this.getMccByCnae();
      } catch (err) {
        this.handleError(err);
      } finally {
        this.mccLoading = false;
      }
    },
    async getMccBySegment() {
      const { data } = await this.requestClass.getMccBySegment(
        this.payload.segmento.value,
      );

      if (!data.data) {
        this.showErrorToast({
          text: 'Nenhuma MCC retornado para este segmento!',
        });
        return;
      }

      this.setMcc(data.data);
    },
    setMcc(data = []) {
      this.mcc = data.reduce(
        (items, item) => {
          items.push({
            text: `(${item.mcc}) - ${item.mccDescription}`,
            value: item.paynetMccId,
          });
          return items;
        },
        [],
      );

      if (this.mcc.length === 1) {
        const [mcc] = this.mcc;
        this.payload.mcc = mcc;
      }
    },
    async getMccByCnae() {
      const { data } = await this.requestClass.getMccByCnae(
        this.payload.cnae.value,
      );

      if (!data.data) {
        this.showErrorToast({
          text: 'Nenhum MCC retornado para este CNAE!',
        });
        return;
      }

      this.setMcc(data.data);
    },
    async getBanks() {
      try {
        this.bankLoading = true;
        const { data: { data = [] } } = await this.bankRequest.list(
          this.makeParams({
            ApenasBancoPaynet: true,
          }),
        );

        this.bankOptions = data.map(
          (item) => ({
            value: item.id,
            text: `${item.code} - ${item.name}`,
          }),
        );
      } catch (err) {
        this.handleError(err);
      } finally {
        this.bankLoading = false;
      }
    },
    async getPrices() {
      try {
        this.priceLoading = true;
        const { data: { data = [] } } = await this.tablePriceService.list(
          this.makeParams(),
        );

        this.prices = data.map(
          (item) => ({
            value: item.id,
            text: item.descricao,
          }),
        );
      } catch (err) {
        this.handleError(err);
      } finally {
        this.priceLoading = false;
      }
    },
    async getRates() {
      try {
        this.ratesLoading = true;
        const { data: { data = [] } } = await this.taxService.list(this.makeParams());

        this.rates = data.map(
          (item) => ({
            value: item.id,
            text: item.descricao,
          }),
        );
      } catch (err) {
        this.handleError(err);
      } finally {
        this.ratesLoading = false;
      }
    },
    overrideCreatePayload() {
      const {
        mcc, tabelaDePrecoId, comAntecipacao, contaBancaria,
        faixaId, custoLocacao, rg, nacionalidade,
        cnae,
        segmento,
      } = this.payload;
      const { bancoId, ...bankAccount } = contaBancaria;

      return {
        rg,
        mccId: Number(mcc.value),
        sgvClienteId: this.getSelectStore.idClienteSgv,
        custoLocacao: !Number.isNaN(custoLocacao) && Number(custoLocacao) > 0 ? custoLocacao : null,
        faixaId,
        tabelaDePrecoId,
        nacionalidade,
        origem: 'BackOffice',
        comAntecipacao,
        contaBancaria: {
          ...bankAccount,
          bancoId: bancoId.value,
          holderType: this.hasCnpj ? 'PessoaJuridicaEmpresa' : 'PessoaFisicaRepresentante',
          document: this.hasCnpj ? this.getFilialDocument : null,
        },
        cnaeSegmentoId: this.hasCnpj ? cnae.value : segmento.value,
      };
    },
    validateSuccess(data) {
      console.log(data);
      if (!data || !data.analiseTableId) {
        this.reloadFlow();
      } else {
        this.isAnalysisTable = true;
      }
    },
    reloadFlow() {
      this.payload = { ...makeInitialData() };
      this.next(1);
    },
    closeAnalyis() {
      this.isAnalysisTable = false;
      this.reloadFlow();
    },
    makeParams(fault = {}) {
      return {
        PerPage: 1000,
        ...fault,
      };
    },
    handleError(response, faultMessage = '') {
      let message = faultMessage;
      if (response && response.data && response.data.message) {
        message = response.data.message;
      }
      this.showErrorToast({
        text: message,
      });
    },
  },
  provide() {
    return {
      setDataLoading: (bool) => {
        this.laoding = bool;
      },
    };
  },
};
</script>
